import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'ebw-monorepo-sidebar-header',
  templateUrl: './sidebar-header.component.html',
  styleUrls: ['./sidebar-header.component.scss'],
  imports: [CommonModule, MatIconModule, TranslateModule]
})
export class SidebarHeaderComponent {
  @Input() public icon;
  @Input() public title;
  @Input() public isSvg: boolean = true;
  @Input() public isOutline: boolean = false;
  @Input() public fill: boolean = false;
  @Input() public vertical: boolean = false;
}
